import React, { useEffect, useReducer } from 'react';

import {
  CheckboxSelected,
  CheckboxUnselected,
  Disconnect
} from '@bypasslane/clover--icons-sprout-functional';
import PropTypes from 'prop-types';

const passwordCriteriaArray = [
  { label: 'At least 8 characters', regex: /.{8,}/ },
  { label: 'At least one uppercase letter', regex: /[A-Z]/ },
  { label: 'At least one lowercase letter', regex: /[a-z]/ },
  { label: 'At least one number', regex: /\d/ },
  { label: 'At least one special character', regex: /[^A-Za-z0-9]/ }
];

const criteriaReducer = (state, action) => {
  switch (action.type) {
    case 'SET_RESULTS': {
      return { ...state, ...action.payload };
    }
    case 'RESET': {
      const resetState = {};
      for (const criterion of passwordCriteriaArray) {
        resetState[criterion.label] = 'EMPTY';
      }
      return resetState;
    }
    default: {
      return state;
    }
  }
};

function renderIcon(status) {
  if (status === 'PASS') {
    return <CheckboxSelected size={16} className="mr-2 text-green-600" />;
  } else if (status === 'FAIL') {
    return <Disconnect size={16} className="mr-2 text-red-600" />;
  } else {
    return <CheckboxUnselected size={16} className="mr-2 text-gray-400" />;
  }
}

function PasswordCriteria({ newPassword }) {
  const initialState = {};
  for (const criterion of passwordCriteriaArray) {
    initialState[criterion.label] = 'EMPTY';
  }

  const [criteriaResults, dispatch] = useReducer(criteriaReducer, initialState);

  useEffect(() => {
    if (newPassword) {
      const results = {};
      for (const criterion of passwordCriteriaArray) {
        results[criterion.label] = criterion.regex.test(newPassword) ? 'PASS' : 'FAIL';
      }
      dispatch({ type: 'SET_RESULTS', payload: results });
    } else {
      dispatch({ type: 'RESET' });
    }
  }, [newPassword]);

  return (
    <ul className="mt-2 text-left">
      {passwordCriteriaArray.map((criterion) => (
        <li key={criterion.label} className="flex items-center text-sm">
          {renderIcon(criteriaResults[criterion.label])}
          {criterion.label}
        </li>
      ))}
    </ul>
  );
}

PasswordCriteria.propTypes = {
  newPassword: PropTypes.string
};

export default PasswordCriteria;
